import {
  timeZoneName,
  isTimecopFrozen,
  isWebsocketsEnabled,
  currentTimeUnixMilliseconds,
} from 'helpers/userSessionSettings';

// Import fonts
import 'vendor/fonts/notosans/notosans-vf.scss';
import 'vendor/fonts/crops-icons/crops-icons.scss';

// Main application styles
import 'stylesheets/application.scss';

// maplibre-gl styles
import 'maplibre-gl/dist/maplibre-gl.css';
import '@cropio-js/mapbox-gl-draw/dist/mapbox-gl-draw.css';

// Import required to `expose-loader` plugin for jQuery.
import 'jquery'; // eslint-disable-line no-restricted-imports

// fancybox plugin
// https://github.com/fancyapps/fancybox
// <a data-fancybox="gallery" href="big_1.jpg">...</a>
// FIXME: Used only in several places, should be removed sometime.
import '@fancyapps/fancybox';
import '@fancyapps/fancybox/dist/jquery.fancybox.min.css';

// Bootstrap3 (loaded as jQuery plugin)
import 'bootstrap'; // eslint-disable-line no-restricted-imports

// Popover fix
import 'vendor/bootstrap-popover-fix';

// https://github.com/select2/select2
// $(...).select2()
import 'select2'; // eslint-disable-line no-restricted-imports
import 'select2/select2.css';
// Bootstrap3 style for select2 v3.5
import 'select2-bootstrap-css/select2-bootstrap.css';

// eslint-disable-next-line unicorn/require-module-specifiers, import-x/no-empty-named-blocks
import { } from 'jquery-ujs'; // eslint-disable-line no-restricted-imports

import moment from 'moment';
import 'moment-timezone/builds/moment-timezone-with-data-1970-2030';

import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import weekday from 'dayjs/plugin/weekday';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import localeData from 'dayjs/plugin/localeData';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import isoWeek from 'dayjs/plugin/isoWeek';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import isBetween from 'dayjs/plugin/isBetween';
import minMax from 'dayjs/plugin/minMax';
import weekOfYear from 'dayjs/plugin/weekOfYear';

// https://github.com/dangrossman/daterangepicker
// $(...).daterangepicker()
// FIXME: Used only in several places, should be removed sometime.
import 'bootstrap-daterangepicker/daterangepicker.css';
// bootstrap-daterangepicker style redefine
import 'vendor/bootstrap-daterangepicker/style.scss';

// WeatherIcons font and styles
import 'weathericons/css/weather-icons.css';
import 'weathericons/css/weather-icons-wind.css';

// FontAwesome
import '@fortawesome/fontawesome-pro/css/all.css';
import '@fortawesome/fontawesome-pro/css/v4-shims.css';

import ReactRailsUJS from 'react_ujs';

// Import styles for common libraries
import 'react-virtualized/styles.css';

// Load Views for side-effects
import 'views';

// Daterangepicker selectors bug in Firefox fix
import 'vendor/selectors-bug-in-firefox-fix';

import { createConsumer } from '@rails/actioncable';

dayjs.extend(customParseFormat);
dayjs.extend(localeData);
dayjs.extend(localizedFormat);
dayjs.extend(weekday);
dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(quarterOfYear);
dayjs.extend(isoWeek);
dayjs.extend(advancedFormat);
dayjs.extend(isBetween);
dayjs.extend(minMax);
dayjs.extend(weekOfYear);

// Set default time from global
if (timeZoneName !== undefined) {
  moment.tz.setDefault(timeZoneName);
  dayjs.tz.setDefault(timeZoneName);
}

if (isTimecopFrozen) {
  moment.now = () => currentTimeUnixMilliseconds;
  // @ts-ignore
  dayjs.now = () => currentTimeUnixMilliseconds;
}

// Support component names relative to this directory:
// @ts-ignore
// eslint-disable-next-line no-undef
const componentRequireContext = require.context('components_for_views', false);
ReactRailsUJS.useContext(componentRequireContext); // eslint-disable-line react-hooks/rules-of-hooks

// FIXME: Globals for telematics
/* eslint-disable camelcase */
globalThis.min_speed = 0;
globalThis.max_speed = 60;
globalThis.speed_colorized_enabled = false;
globalThis.stops_colorizing = false;
globalThis.unloading_colorizing = false;
globalThis.stops_time_minutes = 5;
/* eslint-enable camelcase */

if (isWebsocketsEnabled) {
  try {
    globalThis.consumer = createConsumer();
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('Unable to connect websocket:', e);
  }
}
